import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EOnboardingMilestone } from '@feathr/blackbox';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function MilestoneLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  const milestoneMap = {
    [EOnboardingMilestone.InitialAccountSetup]: {
      name: t('Set up your account'),
      isPending: false,
    },
    [EOnboardingMilestone.OmniCampaign]: {
      name: t('Publish your first ad campaign'),
      isPending: false,
    },
    [EOnboardingMilestone.SingleSendCampaign]: {
      name: t('Publish your first email campaign'),
      isPending: false,
    },
  };

  const milestone = milestoneMap[id];

  return (
    <div className={classNames({ [skeleton]: milestone.isPending }, className)}>
      {milestone.name}
    </div>
  );
}

export default observer(MilestoneLabel);
